import { generateRequest } from '@/api/generateRequest'

const config = {
	manageBankDrop: {
		url: '/client/combo/manageBank/drop',
		apiType: 'check',
	},
	openBankDrop: {
		url: '/client/combo/openBank/drop',
		apiType: 'check',
	},
}
const apiBankDrop = {
	manageBankDrop: (data, variable) => generateRequest(data, config.manageBankDrop, variable),
	openBankDrop: (data, variable) => generateRequest(data, config.openBankDrop, variable),
}
export default apiBankDrop
